import React from 'react';
import { Box, Icon, Tooltip } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';

import fmtNum from './fmtNum';
import invertedMessages from './messages';

import './MetricTable.css';

function MetricTable({ metrics, onDrillDown }) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <table
      className='MetricTable'
      aria-label={
        metrics[0]?.label
          ? `${metrics[0].label} metrics table`
          : 'Pre-launch metrics'
      }>
      <thead>
        <tr>
          <th className='MetricTable-colMetric'>{l('Metric')}</th>
          <th className='MetricTable-colCount'>{l('Count')}</th>
        </tr>
      </thead>
      <tbody>
        {metrics.map((m) => (
          <tr key={m.key}>
            <td className='MetricTable-metricCell'>
              <Box className='MetricTable-metricLabelWrap'>
                {l(m.label)}
                {/* Show info icon with tooltip only when description is provided by API */}
                {m.description && (
                  <Tooltip text={l(m.description)} placement='right'>
                    <Box tag='span' className='MetricTable-infoIcon'>
                      <Icon
                        kind='AlertInfoFilled'
                        size='xSmall'
                        color='--color-foreground-neutral-subtle'
                      />
                    </Box>
                  </Tooltip>
                )}
              </Box>
            </td>
            <td className='MetricTable-countCell'>
              {m.count > 0 && onDrillDown ? (
                <button
                  type='button'
                  className='MetricTable-countLink'
                  onClick={() => onDrillDown(m.key, l(m.label))}>
                  {fmtNum(m.count)}
                </button>
              ) : (
                <Box
                  tag='span'
                  className={m.count > 0 ? undefined : 'MetricTable-countZero'}>
                  {fmtNum(m.count)}
                </Box>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

MetricTable.propTypes = {
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
      description: PropTypes.string, // optional — shown as tooltip when provided by API
    })
  ).isRequired,
  onDrillDown: PropTypes.func,
};

MetricTable.defaultProps = { onDrillDown: null };

export default MetricTable;
